<template lang="html">
    <div class="skill" v-if="!editOpen">
        <header>
            <span class="title">{{ skill.discipline }}</span>
            <span class="score">{{ skill.score }} / 10</span>
            <chevron-up-icon
                @click.prevent="open = !open"
                v-if="open"
                class="icon"
            ></chevron-up-icon>
            <chevron-down-icon
                @click.prevent="open = !open"
                v-else
                class="icon"
            ></chevron-down-icon>
        </header>
        <span class="bar"><span :style="{ width: skill.score * 10 + '%' }"></span></span>

        <div v-if="open">
            <div class="copy">
                <p v-html="skill.description"></p>
            </div>

            <span class="title" v-if="skill.lesson">Related Lesson:</span>

            <div
                v-if="skill.lesson"
                class="relatedLessonWrapper"
                :class="{ 'relatedLessonWrapper--locked': relatedLessonLocked }"
            >
                <router-link class="relatedLesson" :to="relatedLessonLink">
                    <span class="date">
                        {{ $date(skill.lesson.date).format("DD MMM YYYY") }}
                    </span>
                    <img
                        class="star"
                        v-if="skill.lesson.starred"
                        src="@/assets/icons/star-fill.svg"
                        alt=""
                    />
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>

                <lesson-locked-overlay v-if="relatedLessonLocked" :lesson="skill.lesson" />
            </div>

            <div class="proControlls" v-if="type == 'pro'">
                <button
                    class="button half"
                    @click.prevent="editOpen = true"
                    type="button"
                    name="button"
                >
                    Edit
                </button>
                <button
                    @click.prevent="deleteSkill"
                    class="button half red"
                    type="button"
                    name="button"
                >
                    Delete
                </button>
            </div>
        </div>
    </div>

    <add-edit-skill
        v-else
        type="edit"
        :skill="skill"
        :editOpen="editOpen"
        @addEditSkillClosed="closeEdit"
        @skillAdded="skillUpdated"
    />
</template>

<script>
import AddEditSkill from "@/views/Pro/Players/Player/partials/add-edit-skill";
import LessonLockedOverlay from "@/components/Player/Lessons/lesson-locked-overlay";
import lessonRecordAccess from "@/mixins/lesson-record-access";
import { ChevronUpIcon, ChevronDownIcon, ChevronRightIcon } from "vue-feather-icons";
export default {
    name: "skills-list-item",
    mixins: [lessonRecordAccess],
    components: {
        AddEditSkill,
        ChevronUpIcon,
        ChevronRightIcon,
        ChevronDownIcon,
        LessonLockedOverlay,
    },
    props: {
        skill: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: "player",
        },
    },
    data() {
        return {
            open: false,
            editOpen: false,
        };
    },
    computed: {
        relatedLessonLocked() {
            return this.type !== "pro" && this.isLessonRecordLocked(this.skill.lesson);
        },
        relatedLessonLink() {
            if (this.$store.state.user.type == "pro") {
                return {
                    name: "proPlayerLesson",
                    params: { id: this.skill.lesson.player_id, lesson: this.skill.lesson.id },
                };
            } else {
                return { name: "playerLesson", params: { id: this.skill.lesson.id } };
            }
        },
    },
    methods: {
        closeEdit() {
            this.editOpen = false;
        },
        skillUpdated($skill) {
            this.$emit("skillUpdated", $skill);
        },
        deleteSkill() {
            this.$confirm("Are you sure you want to delete this skill?", () => {
                window.axios.delete("/skill/" + this.skill.id).then(() => {
                    this.$notify({
                        text: "Skill deleted",
                    });

                    this.$emit("skillRemoved", this.skill);
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.skill {
    background: $green_0;
    padding: 20px;
    border-radius: 12px;
    color: white;
    position: relative;
    margin-bottom: 10px;
    &:last-of-type {
        margin-bottom: 0px;
    }
    header {
        margin-bottom: 20px;
        position: static;
        .score {
            position: absolute;
            right: 50px;
            top: 20px;
        }
        .icon {
            position: absolute;
            right: 15px;
            top: 16px;
            color: #444745;
        }
    }

    .bar {
        display: block;
        width: 100%;
        height: 8px;
        background: #444745;
        border-radius: 5px;
        width: 100%;
        position: relative;
        span {
            position: absolute;
            left: 0px;
            height: 8px;
            display: block;
            width: 60%;
            background: rgb(21, 242, 159);
            background: linear-gradient(
                270deg,
                rgba(21, 242, 159, 1) 0%,
                rgba(38, 121, 98, 1) 100%
            );
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
}
.copy {
    margin-bottom: 20px;
    margin-top: 20px;
}
.title {
    margin-bottom: 10px;
    display: block;
    line-height: 1.5;
    padding-right: 100px;
}
.proControlls {
    margin-top: 20px;
}
.relatedLessonWrapper {
    position: relative;

    &--locked {
        .relatedLesson {
            min-height: 5em;
        }
    }
}
.relatedLesson {
    display: block;
    text-decoration: none;
    color: white;
    background: #444745;
    padding: 15px;
    border-radius: 12px;
    position: relative;
    .star {
        position: absolute;
        right: 35px;
        top: 15px;
    }
    .icon {
        position: absolute;
        right: 10px;
        top: 11px;
    }
}
</style>
